import React, {useContext, useEffect, useState} from 'react'

export const DragElementsContext = React.createContext()



function DnDContextProvider(props){
    const [dragElementsData, setDragElementsData] = useState()
    const [droppedElementsInTarget, setDroppedElementsInTarget] = useState([])
    const [currentDrag, setCurrentDrag] = useState()
    const [currentDragOverTarget, setCurrentDragOverTarget] = useState(false)

    function initDragElementsData(dndRecord){
        const sortedByInitPos = dndRecord.sort((a, b) => a.initPos - b.initPos);
        const newDragElements = sortedByInitPos.map(element => {
            return {
                text: element.text,
                belongsTo: element.targetPos,
                currentlyAt: element.initPos,
            }
        })
        setDragElementsData(newDragElements)   
    }


    function dropInTarget(name, currentlyAt, belongsTo){
        const newOne = {
            name,
            currentlyAt,
            belongsTo
        }
        setDroppedElementsInTarget(current => [...current, newOne])
//        removeFromDragElements(name)
    }

    function checkDroppedElementsCorrect(){
        let acc = true
        for (const element of droppedElementsInTarget) {
            acc = acc && element.currentlyAt === parseInt(element.belongsTo)
        }    
        return acc
    }

    function removeFromDragElements(data){
        const filtered = dragElementsData.filter(element => {
            return element.text !== data
        })
        setDragElementsData(filtered)
    }

    function addToDragElementsData(data){
        const newElement = {
            text: data.split("__")[0],
            belongsTo: data.split("__")[1],
            currentlyAt: data.split("__")[2],
        }
        let exiisting = []
        exiisting = dragElementsData.filter(element => {
            return element.text === newElement.text
        })
        if(typeof exiisting != 'undefined' && Array.isArray(exiisting) && exiisting.length === 0){
            setDragElementsData(current => [...current, newElement]);
        }
    }

    function informContextAboutDrag(dragElementData){
        setCurrentDrag(dragElementData)
    }

    function informContextDragOver(isOverTarget){
        setCurrentDragOverTarget(isOverTarget)

        console.log("set dragging OVER target " + isOverTarget)
    }


    



    return (
        <DragElementsContext.Provider value={{
            dragElementsData,
            initDragElementsData,
            removeFromDragElements,
            addToDragElementsData,
            dropInTarget,
            checkDroppedElementsCorrect,
            informContextAboutDrag,
            informContextDragOver,
            currentDrag,
            currentDragOverTarget
            }}>
            {props.children}
        </DragElementsContext.Provider>
    )
}
export default DnDContextProvider